import request from '@/utils/request'

export function getDictionary(id) {
    return request({
        url: '/getDictionary/' + id,
        method: 'get',
    })
}

export function ocr(data) {
    return request({
        url: '/ocr',
        method: 'post',
        data
    })
}

export function checkAdmin() {
    return request({
        url: '/checkAdmin',
        method: 'get',
    })
}

export function initAdmin(data) {
    return request({
        url: '/initAdmin',
        method: 'post',
        data
    })
}

export function getKnowledgeBaseFileList(data) {
    return request({
        url: '/KnowledgeBaseFile',
        method: 'get',
        params: data
    })
}

export function getBasicSystemModelList(data) {
    return request({
        url: '/BasicSystemModelList',
        method: 'get',
        params: data
    })
}

export function getBasicSystem(data) {
    return request({
        url: '/BasicSystem',
        method: 'get',
        params: data
    })
}

export function updateBasicSystem(data) {
    return request({
        url: '/BasicSystem',
        method: 'post',
        data
    })
}

export function voiceSiliconflowApi(data) {
    return request({
        url: '/voice/SiliconflowApi',
        method: 'post',
        data
    })
}

export function BrowseRecord(data) {
    return request({
        url: '/BrowseRecord',
        method: 'post',
        data
    })
}

export function myCreate(params) {
    return request({
        url: '/myCreate',
        method: 'get',
        params
    })
}


export function RecentlyUsed(data) {
    return request({
        url: '/RecentlyUsed',
        method: 'post',
        data
    })
}



export function getKbToken(params) {
    return request({
        url: '/InsightKB/getToken',
        method: 'get',
        params
    })
}